import { SVGProps } from './types';

const RadioCheckedIcon = (props: SVGProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z"
        fill="#14120F"
      />
      <circle cx="9.99984" cy="10.0001" r="3.33333" fill="white" />
    </svg>
  );
};

export { RadioCheckedIcon };
